import { ForwardRefExoticComponent, ReactNode } from 'react';
import { TransProps } from 'react-i18next';

import { Group, GroupColorMap, S3VideoObjectInput, UserProfile } from 'api';

export interface ITimeline {
  id: UserProfile['id'];
  title: string;
  color_map: Partial<GroupColorMap>;
  allow_user_posts: boolean;
}

export type UserGroup = Group | ITimeline;

export enum AspectRatios {
  square = 2 / 2,
  wide = 16 / 9,
  none = NaN,
}

export enum PostAction {
  Create = 'Create',
  Edit = 'Edit',
}

export enum PostState {
  View = 'View',
  Edit = 'Edit',
  Customize = 'Customize',
}

export interface IContentLayoutProps {
  selectedGroup?: UserGroup;
}

export type LoaderTypes = 'standard' | 'widget' | 'none' | ReactNode;

// Values are corresponding routes
export enum SuggestionTypes {
  Group = 'group',
  Profile = 'profile',
}

// Values are corresponding routes
export enum SearchResultTypes {
  Group = 'group',
  Profile = 'profile',
  Content = 'content',
}

export interface IFilter {
  component: ForwardRefExoticComponent<any>;
  isSelected: boolean;
  textNode: ReactNode;
  subMenu?: IFilter[];
}

export interface IClientSettingParams {
  department_id: string;
  location_id: string;
}

export interface IVideoInput extends S3VideoObjectInput {
  file?: File;
}

export interface INotify {
  duration?: number;
  component?: ReactNode;
  message?: any;
  i18n?: TransProps;
}

export type NotifyTypes = 'error' | 'info' | 'queryError' | 'mutationError';

export enum DateRange {
  Last7Days = 'last-7-days',
  Last30Days = 'last-30-days',
  Last60Days = 'last-60-days',
  LastXDays = 'last-X-days',
}
